import React, { Component } from "react";
import CreatableSelect from "react-select/creatable";

const orderOptions = values => {
  return values.filter(v => v.isFixed).concat(values.filter(v => !v.isFixed));
};

const styles = {
  multiValue: (base, state) => {
    return state.data.isFixed ? { ...base, backgroundColor: "gray" } : base;
  },
  multiValueLabel: (base, state) => {
    return state.data.isFixed
      ? { ...base, fontWeight: "bold", color: "white", paddingRight: 6 }
      : base;
  },
  multiValueRemove: (base, state) => {
    return state.data.isFixed ? { ...base, display: "none" } : base;
  }
};

const setFixedValues = (arr, fixedValues) => {
  if (!arr) {
    return [];
  }
  for (let i = 0; i < arr.length; i++) {
    const val = arr[i];
    val.isFixed = fixedValues.some(v => v.value === val.value);
  }
  return [...arr];
};

export default class MultiSelectTextInput extends Component {
  state = {
    inputValue: "",
    value: [],
    options: []
  };

  handleChange = (value, { action, removedValue }) => {
    // eslint-disable-next-line
    switch (action) {
      case "remove-value":
      case "pop-value":
        if (removedValue.isFixed) {
          return;
        }
        break;
      case "clear":
        value = this.props.values.filter(v => v.isFixed);
        break;
    }
    if (value && !Array.isArray(value)) {
      value = [value];
    }
    this.props.handleChange((value || []).map(f => f.value));
  };
  handleInputChange = inputValue => {
    this.setState({ inputValue });
  };

  handleKeyDown = event => {
    const { inputValue } = this.state;
    if (!inputValue) return;
    // eslint-disable-next-line
    switch (event.key) {
      case "Enter":
      case "Tab":
      case ",":
        if (!this.props.values.some(v => v === inputValue)) {
          const values = [...this.props.values, inputValue];
          this.props.handleChange(values);
        }

        this.setState({
          inputValue: ""
        });
        event.preventDefault();
    }
  };

  render() {
    const { inputValue } = this.state;
    const values = orderOptions(
      setFixedValues(
        this.props.values.map(f => {
          return { label: f, value: f };
        }),
        this.props.fixedOptions
      )
    );
    return (
      <CreatableSelect
        components={
          this.props.showMenu
            ? undefined
            : {
              DropdownIndicator: null
            }
        }
        inputValue={inputValue}
        isClearable={this.props.fixedOptions.length === 0}
        isMulti
        styles={styles}
        menuIsOpen={this.props.showMenu ? undefined : false}
        onChange={this.handleChange}
        onInputChange={this.handleInputChange}
        onKeyDown={this.handleKeyDown}
        value={values}
        isDisabled={this.props.disabled}
        {...this.props}
      />
    );
  }
}
